<template lang="html">

  <section class="banner-newsletter row-center ais">
    <div class="left">

      <div class="info-contacto row-end">
        <div class="container -half">
          <h2 class="title -black">{{ $t('banner_newsletter.titulo') }}</h2>
          <template v-if="siteMex">
            <p class="-email">{{ $t('banner_newsletter.email') }} <a
                href="mailto:ventas@momenglobal.com">ventas@momenglobal.com</a></p>
              <p class="-whatssap"><span>WhatsApp: </span> <span><a target="_blank"
                  href="https://wa.me/522204419904">+52 220 441 9904</a></span></p>
          </template>
          <template v-else>
            <p class="-direccion">{{ $t('banner_newsletter.cuerpo') }}</p>
            <p class="-email">{{ $t('banner_newsletter.email') }} <a
                href="mailto:info@aldonzagourmet.com">info@aldonzagourmet.com</a></p>
            <p class="-telefono"><span>{{ $t('banner_newsletter.telefono') }}</span> <span><a
                  href="tel:+0034967217711">(+34) 967 21 77 11</a></span> <span class="line">-</span> <span><a
                  href="tel:+0034660634959">(+34) 660 634 959</a></span></p>

            <div class="dist-ruso-box" v-if="lang == 'ru'">

              <div class="content">
                <p class="mb-0"><strong>Официальный дистрибьютор продукции Aldonza</strong></p>
                <p><a href="mailto:luxfoodkz@gmail.com">luxfoodkz@gmail.com</a> |
                  <span><a href="tel:+77007709595 ">+77007709595</a></span>
                </p>
              </div>
              <img src="/static/img/logo-lux-food.png" alt="logo-lux-food">
            </div>
          </template>
        </div>
      </div>


    </div>

    <div class="newsletter">

      <div class="texto">

        <h2 class="title -black">{{ $t('newsletter.titulo') }}</h2>

        <p>{{ $t('newsletter.cuerpo') }}</p>

        <div class="contenedor-input -black row-start">
          <label for="">{{ $t('formulario.email') }}*</label>
          <input type="text" v-model="email" name="email" :placeholder="$t('formulario.introduce_mail')"
            v-validate="'required|email'">
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('email') }}</span>
        </div>

        <div class="contenedor-check -black">
          <input type="checkbox" id="politica-newsletter" v-validate="'required'" name="politica" v-model="politica">
          <label for="politica-newsletter">{{ $t('formulario.he_leido') }} <router-link
              :to="$t('enlaces.politica_proteccion')">{{ $t('formulario.y_acepto') }}</router-link></label>
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('politica') }}</span>
        </div>

        <div class="contenedor-check -black">
          <input type="checkbox" id="comunicaciones-newsletter" v-validate="'required'" name="comunicaciones"
            v-model="comunicaciones">
          <label for="comunicaciones-newsletter">{{ $t('newsletter.texto_comunicaciones') }}</label>
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('comunicaciones')
            }}</span>
        </div>

        <div class="contenedor-boton">
          <button :enviado="enviado" class="btn -black" @click="validateBeforeSubmit">
            <span>{{ $t('newsletter.boton') }}</span>
          </button>
          <p class="enviado" :enviado="enviado">{{ $t('newsletter.enviado') }}</p>
        </div>

      </div>

    </div>
  </section>

</template>

<script lang="js">

import mapa from '@/components/parts/mapa'

import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'banner-newsletter',
  mounted() {
    if (window.location.hostname.includes('.com.mx')) {
      this.siteMex = true
    }
  },
  data() {
    return {
      email: '',
      clicked: false,
      enviado: false,
      politica: false,
      comunicaciones: false,
      siteMex: false
    }
  },
  components: {
    'mapa': mapa
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage'
    }),
  },
  methods: {
    ...mapActions(['sendNewsletter']),
    validateBeforeSubmit: function () {

      this.clicked = true;

      this.$validator.validateAll().then(canSend => {
        if (canSend) {
          this.loading = true;

          let data = {
            email: this.email,
            lang: this.lang,
            aldonza: 1
          }

          this.sendNewsletter(data)
            .then(result => {
              if (result) {
                this.enviado = true;
                this.email = '';
                this.politica = false
                this.clicked = false;
              }
              this.loading = false;
            }).catch(e => {
              this.loading = false;
            });

        }
      });


    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/colors.scss";

.banner-newsletter {
  overflow: hidden;
  min-height: 100vh;
  padding-bottom: 23vw;
  background: url("/static/img/background-banner-donde-estamos.jpg") center bottom/100% auto no-repeat;
  transition: 1s;
  opacity: 0;
}

.mapa {
  width: 100%;
  display: inline-block;
  min-height: 350px;
  opacity: 0;
  transition-delay: 1.4s;
  transition-duration: 2s;
  transform: translateY(400px);
}

.title {
  font-size: 24px;
  margin-bottom: 20px;
}

.info-contacto {
  padding: 50px;
  opacity: 0;
  transition-delay: 1s;
  transition-duration: 2s;
  transform: translateY(400px);
}

.left {
  width: 50%;
  color: black;
}

.error {
  color: red;
}

.newsletter {
  width: 50%;
  padding: 50px;
  color: black;

  .texto {
    opacity: 0;
    transition-delay: 1s;
    transition-duration: 2s;
    transform: translateY(400px);
    max-width: 700px;
  }

  p {
    margin-bottom: 15px;
    color: black;
  }

}

.page.contacto .banner-newsletter .newsletter,
.page.contacto .banner-newsletter .info-contacto {
  padding-top: 280px;
}

.launched {

  .banner-newsletter {
    opacity: 1;
  }

  .mapa {
    transform: translateY(0);
    opacity: 1;
  }

  .info-contacto {
    transform: translateY(0);
    opacity: 1;
  }

  .newsletter .texto {
    transform: translateY(0);
    opacity: 1;
  }
}

.contenedor-boton {
  position: relative;
}

.enviado {
  text-align: center;
  position: absolute;
  left: 0;
  width: 100%;
  top: 50%;
  height: 30px;
  line-height: 30px;
  margin-top: -15px;
  opacity: 0;
  pointer-events: none;
  transform: translateY(100px);
  transition: .7s;

  &[enviado=true] {
    opacity: 1;
    transform: none;
  }
}

.btn[enviado=true] {
  transform: translateY(-100px);
  opacity: 0;
  transition: .5s;
}

@media screen and (max-width: 1100px) {
  .left {
    width: 100%;
  }

  .newsletter {
    width: 100%;
  }


  .page.contacto .banner-newsletter .info-contacto {
    padding: 25px 0;
  }

  .page.contacto .banner-newsletter .newsletter {
    padding: 25px 25px;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -ms-align-items: center;
    align-items: center;
    justify-content: center;
    -webkit-justify-content: center;

    .texto {
      max-width: 615px;
      width: 100%;
      padding: 0 25px;
    }
  }

  .banner-newsletter {
    padding-bottom: 30vw;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media screen and (max-width: 1023px) {
  .page.contacto .banner-newsletter .newsletter .texto {
    max-width: 100%;
    padding: 0;
  }

  .banner-newsletter {
    padding: 0 0 30vw 0;
    -ms-align-items: flex-start;
    align-items: flex-start;
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    min-height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-newsletter.vue